import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var upload_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M18.5 15v3.5H13V6.7l4.5 4.1 1-1.1-6.2-5.8-5.8 5.8 1 1.1 4-4v11.7h-6V15H4v5h16v-5z" }) });
export {
  upload_default as default
};
//# sourceMappingURL=upload.js.map
